import React from 'react';
import {BrowserRouter as Router, useRoutes} from 'react-router-dom';
import routes from './config/routes';
import PrivateRoute from './components/auth/PrivateRoute';

const AppRoutes: React.FC = () => {
  const element = useRoutes(routes);
  return <PrivateRoute>{element}</PrivateRoute>;
};

const App: React.FC = () => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppRoutes />
    </Router>
  );
};

export default App;
